import React from 'react';
import clsx from 'clsx';

/** Вкладки с подчёркиванием. items: [{ id, label, icon?, count? }] */
export function Tabs({ items, value, onChange, className }) {
  return (
    <div className={clsx('-mx-1 overflow-x-auto border-b border-zinc-200 custom-scrollbar dark:border-zinc-800', className)}>
      <div role="tablist" className="flex min-w-max gap-1 px-1">
        {items.map(({ id, label, icon: Icon, count }) => {
          const active = id === value;
          return (
            <button
              key={id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onChange(id)}
              className={clsx(
                '-mb-px inline-flex items-center gap-2 border-b-2 px-3 py-2.5 text-sm font-medium transition-colors',
                active
                  ? 'border-brand-600 text-brand-700 dark:border-brand-400 dark:text-brand-300'
                  : 'border-transparent text-zinc-500 hover:border-zinc-300 hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-200'
              )}
            >
              {Icon && <Icon className="h-4 w-4" />}
              {label}
              {count !== undefined && count !== null && (
                <span className="tabular rounded-full bg-zinc-100 px-1.5 text-[11px] text-zinc-600 dark:bg-zinc-800 dark:text-zinc-400">{count}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
